<template>
  <div class="mdt-search">
    <MdtInput
      :id="id"
      :value="searchValue"
      :placeholder="placeholder"
      :size="size"
      :class="{ active: !isFocused && searchValue.length }"
      :test-key="`${testKey}-search`"
      @blur="isFocused = false"
      @focus="isFocused = true"
      @input="onInput">
      <i
        v-show="!searchValue.length"
        slot="icon"
        class="fas fa-search no-value" />
      <i
        v-show="searchValue.length"
        slot="icon"
        class="fas fa-times-circle has-value pointer"
        @click="resetValue" />
    </MdtInput>
  </div>
</template>

<script>
import { helpers } from '@/utility';

export default {
  name: 'MdtSearch',
  props: {
    value: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'size-40',
      validator: (value) => ['size-40', 'size-32'].includes(value),
    },
    id: {
      type: String,
      default: 'search',
    },
    testKey: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isFocused: false,
      internalValue: this.value,
      debouncedSearch: null,
    };
  },
  computed: {
    searchValue: {
      get() {
        return this.internalValue;
      },
      set(val) {
        this.internalValue = val;
        if (this.debouncedSearch) {
          this.debouncedSearch();
        }
      },
    },
  },
  watch: {
    value(newVal) {
      this.internalValue = newVal;
    },
  },
  created() {
    // Initialize debounce ONCE
    this.debouncedSearch = helpers.debounce(this.search, 600);
  },
  methods: {
    search() {
      this.$emit('input', this.internalValue);
      this.$emit('search', this.internalValue);
    },
    resetValue() {
      this.internalValue = '';
      this.search();
    },
    onInput(val) {
      // Sync input event from MdtInput to computed setter
      this.searchValue = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.mdt-search {
  min-width: 200px;
}
</style>
